import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openSearch: false,
    Loading: false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
